// parallax.js


/**
 * Calculle la position de l'element par rapport au haut de la page
 * @param {HTMLElement} element 
 * @return {number}
 */
const offsetTop = (element, acc = 0) => {
  if (element.offsetParent) {
    return offsetTop(element.offsetParent, acc + element.offsetTop)
  }
  return acc + element.offsetTop;
};


class Parallax {
  /**
   * @param {HTMLElement} element 
   */
  constructor(element) {
    this.element = element;
    this.options = this.parseAttribute();
    // this.ratio = parseFloat(element.dataset.parallax);
    this.noAnimBreakpoint = element.dataset?.parallaxStop
      ? parseFloat(element.dataset.parallaxStop) : 0;
    this.onScroll = this.onScroll.bind(this);
    this.onIntersection = this.onIntersection.bind(this);
    this.elementY = offsetTop(this.element) + this.element.offsetHeight / 2;
    const observer = new IntersectionObserver(this.onIntersection);
    observer.observe(element);
    this.onScroll;
  }

  /**
   * 
   * @param {IntersectionOberserverEntry[]} entries 
   */
  onIntersection(entries) {
    for (const entry of entries) {
      if (entry.isIntersecting) {
        document.addEventListener('scroll', this.onScroll);
        this.elementY = offsetTop(this.element) + this.element.offsetHeight / 2;
      } else {
        document.removeEventListener('scroll', this.onScroll);
      }
    }
  }


  onScroll() {
    window.requestAnimationFrame(() => {
      const screenY = window.scrollY + window.innerHeight / 2;
      const diffY = this.elementY - screenY;
      
      const translateValueX = this.options.ratio.x && window.innerWidth > this.noAnimBreakpoint
      ? diffY * -1 * this.options.ratio.x + 'px' : 0;
      
      const translateValueY = this.options.ratio.y && window.innerWidth > this.noAnimBreakpoint
      ? diffY * -1 * this.options.ratio.y + 'px' : 0;
      
      this.element.style.setProperty(
        'transform',
        `translate(${translateValueX}, ${translateValueY})`)
    });
  }
  
  
  parseAttribute() {
    const defaultOptions = {
      ratio: {
        x: 0,
        y: 0
      }
    };
    
    if (this.element.dataset.parallax.startsWith('{')) {
      return {
        ratio: {
          ...defaultOptions,
          ...JSON.parse(this.element.dataset.parallax)
        }
      };
    }
    return {
      ...defaultOptions,
      ratio: {
        x: 0,
        y: parseFloat(this.element.dataset.parallax),
      }
    };
  }

  /**
   * @returns {Parallax[]}
   */
  static bind() {
    return Array.from(document.querySelectorAll(".wp-block-plune-blocks-intro-h1 .background img")).map(element => {
      element.setAttribute('data-parallax', '0.18')
      element.setAttribute('data-parallax-stop', '768')
      return new Parallax(element);
    });
  }
}

Parallax.bind();

